import React, { useState } from 'react';

import { apiErrorToMessage } from '@repo/editor/src/global/apiErrorToMessage';
import { useUserStore } from '@repo/editor/src/stores/userStore';
import { withEventScope } from '@repo/event-processor';
import { Button } from '@repo/ui/components/Buttons';
import { TextInput } from '@repo/ui/components/Inputs';
import { H2, P2 } from '@repo/ui/components/Typography';

import teamsApi from 'global/teamsApi';

import { Wrapper } from './styles';
import { CreateTeamModalContentProps } from './types';

const CreateTeamModalContent: React.FC<CreateTeamModalContentProps> = ({
  onSuccess,
}) => {
  const [teamName, setTeamName] = useState('');
  const [error, setError] = useState<string | undefined>();
  const [loading, setLoading] = useState(false);

  const handleChange = (value: string): void => {
    setError(undefined);
    setTeamName(value);
  };

  const handleSubmit = async (): Promise<void> => {
    setError(undefined);

    const sanitizedName = teamName.trim();
    if (!sanitizedName) {
      setError('Name your team');
      return;
    }
    setLoading(true);

    const response = await teamsApi.create(sanitizedName);

    if (!response.success) {
      let error: string = response.error;

      if (error) {
        error = apiErrorToMessage(error);
      } else {
        error = 'Something went wrong!';
      }

      setError(error);
    } else {
      await useUserStore.getState().updateUser(response.token, false);
      onSuccess(response.team);
    }

    setLoading(false);
  };

  return (
    <Wrapper>
      <H2>Create new team</H2>
      <P2>
        After creating a team, you can choose a team plan and invite members to
        join.
      </P2>
      <TextInput
        errorMessage={error}
        name="teamname"
        placeholder="Add team name"
        theme={{ height: '48px' }}
        value={teamName}
        onChanging={handleChange}
        onEnter={handleSubmit}
      />
      <Button
        height="48px"
        label="Create Team ->"
        loading={loading}
        name="createTeamButton"
        width="176px"
        onClick={handleSubmit}
      />
    </Wrapper>
  );
};

export default withEventScope(CreateTeamModalContent, {
  module: 'createTeamModal',
});
